module.exports = __webpack_public_path__ + "static/media/heap_snapshot_large_dropdown.66638907.svg";